import React, { useState } from 'react';
import {
  FaBars,
  FaTimes,
  FaGithub,
  FaLinkedin
} from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';
import { BsFillPersonLinesFill } from 'react-icons/bs';
import Logo from '../assets/pj-logo-small.png';
import { Link } from 'react-scroll';

// Data
const Resume = `https://data.piotrjurski.com/resume/Piotr_Jurski_Resume.pdf`;

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  return (
    <div className='nav-pj fixed w-full h-[80px] flex justify-between items-center px-4 bg-[#008CD3] text-gray-300 z-50'>
      <div className='flex px-2'>
        <Link className='no-underline hover:underline underline-offset-8 decoration-[#9A1AF8] decoration-4' to='home' smooth={true} duration={500}>
          <img src={Logo} alt='Piotr Jurski Logo' style={{ width: '50px' }} />
        </Link>
        {/* <img className='mt-1 flex content-center text-center' src={PJName} alt='Piotr Jurski Logo' style={{ width: '210px', height: '30px'}} /> */}
      </div>

      {/* menu */}
      <ul className='hidden md:flex'>
        <li className='no-underline hover:underline underline-offset-8 decoration-[#9A1AF8] decoration-4'>
          <Link to='home' smooth={true} duration={500}>
            Home
          </Link>
        </li>
        <li className='no-underline hover:underline underline-offset-8 decoration-[#9A1AF8] decoration-4'>
          <Link to='about' smooth={true} duration={500}>
            About
          </Link>
        </li>
        <li className='no-underline hover:underline underline-offset-8 decoration-[#9A1AF8] decoration-4'>
          <Link to='whatido' smooth={true} duration={500}>
            What I Do
          </Link>
        </li>
        <li className='no-underline hover:underline underline-offset-8 decoration-[#9A1AF8] decoration-4'>
          <Link to='skills' smooth={true} duration={500}>
            Skills
          </Link>
        </li>
        {/* <li>
          <Link to='work' smooth={true} duration={500}>
            Work
          </Link>
        </li> */}
        <li className='no-underline hover:underline underline-offset-8 decoration-[#9A1AF8] decoration-4'>
          <Link to='contact' smooth={true} duration={500}>
            Contact
          </Link>
        </li>
      </ul>

      {/* Hamburger */}
      <div onClick={handleClick} className='md:hidden z-10'>
        {!nav ? <FaBars /> : <FaTimes />}
      </div>

      {/* Mobile menu */}
      <ul
        className={
          !nav
            ? 'hidden'
            : 'absolute top-0 left-0 w-full h-screen bg-[#0a0a5a] flex flex-col justify-center items-center'
        }
      >
        <li className='py-6 text-4xl no-underline hover:underline underline-offset-8 decoration-[#9A1AF8] decoration-4'>
          <Link onClick={handleClick} to='home' smooth={true} duration={500}>
            Home
          </Link>
        </li>
        <li className='py-6 text-4xl no-underline hover:underline underline-offset-8 decoration-[#9A1AF8] decoration-4'>
          {' '}
          <Link onClick={handleClick} to='about' smooth={true} duration={500}>
            About
          </Link>
        </li>
        <li className='py-6 text-4xl no-underline hover:underline underline-offset-8 decoration-[#9A1AF8] decoration-4'>
          {' '}
          <Link onClick={handleClick} to='whatido' smooth={true} duration={500}>
            What I Do
          </Link>
        </li>
        <li className='py-6 text-4xl no-underline hover:underline underline-offset-8 decoration-[#9A1AF8] decoration-4'>
          {' '}
          <Link onClick={handleClick} to='skills' smooth={true} duration={500}>
            Skills
          </Link>
        </li>
        {/* <li className='py-6 text-4xl'>
          {' '}
          <Link onClick={handleClick} to='work' smooth={true} duration={500}>
            Work
          </Link>
        </li> */}
        <li className='py-6 text-4xl no-underline hover:underline underline-offset-8 decoration-[#9A1AF8] decoration-4'>
          {' '}
          <Link onClick={handleClick} to='contact' smooth={true} duration={500}>
            Contact
          </Link>
        </li>
        <li className='py-6 text-4xl no-underline hover:underline underline-offset-8 decoration-[#9A1AF8] decoration-4'>
          {' '}
          <Link to={"route"} onClick={(event) => {event.preventDefault();window.open(Resume);}}>
            Resume
          </Link>
        </li>
      </ul>

      {/* Social icons */}
      <div className='hidden lg:flex fixed flex-col top-[320%] left-0'>
        <ul>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-blue-600'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href='https://www.linkedin.com/in/pjurski/'
              target={'_blank'}
              rel="noreferrer"
            >
              LinkedIn <FaLinkedin size={30} />
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#333333]'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href='https://github.com/piotrjurski'
              target={'_blank'}
              rel="noreferrer"
            >
              Github <FaGithub size={30} />
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#000]'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href='mailto:pjurski@jurskinyc.com'
              target={'_blank'}
              rel="noreferrer"
            >
              Email <HiOutlineMail size={30} />
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#9A1AF8]'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              href={Resume}
              download="Piotr_Jurski_Resume.pdf"
              target={'_blank'}
              rel="noreferrer"
            >
              Resume <BsFillPersonLinesFill size={30} />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
